var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductFeaturedStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160.4 163.3",
    style: {
      enableBackground: "new 0 0 160.4 163.3"
    },
    xmlSpace: "preserve",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "star_2_",
    className: "st0",
    d: "M138,65.1c-0.6-2.6-2.7-4.6-5.3-5l-33.6-3.6L85.9,19.6c-0.8-2.6-3.1-4.3-5.7-4.4 c-2.6,0.1-4.9,1.9-5.7,4.5L61.3,56.5l-33.6,3.6c-2.6,0.4-4.7,2.4-5.3,5c-0.8,2.7-0.1,5.7,1.8,7.8l25.4,26.4l-7.5,39.1 c-0.6,2.8,0.3,5.6,2.4,7.6c1,0.9,2.3,1.4,3.6,1.4c1.1,0,2.2-0.4,3.2-1l28.9-20.5l28.9,20.5c2.1,1.5,4.9,1.4,6.8-0.4 c2.1-1.9,3-4.8,2.4-7.6l-7.4-39.2l25.4-26.4C138.2,70.8,138.8,67.8,138,65.1L138,65.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductFeaturedStar);
export default __webpack_public_path__ + "static/media/product-featured-star.99f28a8f.svg";
export { ForwardRef as ReactComponent };